<section class="section-title">

  <div class="section-title-image">
    <img class="user-image" src="assets/img/device-pilomat.png" />
  </div>

  <div class="section-title-text">
    <h1 i18n="@@adddevice_title">Aggiungi dispositivo</h1>
  </div>

</section>

<section>

  <div class="control-card-white" id="user-add-card">

    <div class="control-card-header">
      <ng-container i18n="@@adddevice_data_title">Dati dispositivo</ng-container>
    </div>

    <div class="control-card-content">

      <form [formGroup]="addDeviceForm">
        <table class="simple-table device-add-table">

          <tr>
            <td width="180px" class="text-dark" i18n="@@adddevice_name">Nome</td>
            <td><input id="name-input" formControlName="name" [(ngModel)]="name" required></td>
          </tr>
          <tr>
            <td width="180px" class="text-dark" i18n="@@adddevice_date">Data di produzione</td>
            <td><input id="name-input" formControlName="date" [(ngModel)]="productionDate"></td>
          </tr>
          <tr>
            <td width="180px" class="text-dark" i18n="@@adddevice_model">Modello</td>
            <td><input id="name-input" formControlName="model" [(ngModel)]="model"></td>
          </tr>
          <tr>
            <td width="180px" class="text-dark" i18n="@@adddevice_description">Descrittivo</td>
            <td><input id="name-input" formControlName="reference" [(ngModel)]="reference"></td>
          </tr>
          <tr>
            <td width="180px" class="text-dark" i18n="@@adddevice_city">Città</td>
            <td><input id="name-input" formControlName="city" [(ngModel)]="city"></td>
          </tr>
          <tr>
            <td width="180px" class="text-dark" i18n="@@adddevice_address">Indirizzo</td>
            <td><input id="name-input" formControlName="address" [(ngModel)]="address"></td>
          </tr>
        </table>
      </form>

      <a (click)="printStuff()" class="button user-add-button">
        <ng-container i18n="@@adddevice_create_user">Aggiungi</ng-container> <span>
          <fa-icon icon="save"></fa-icon>
        </span>
      </a>

      <app-loading-screen #adddeviceloader [loading]="false" [showtext]="false"></app-loading-screen>

    </div>

  </div>

</section>
